import fetch from 'cross-fetch';
// 參照到已建立的store物件，要注意的只有使用其方法時，該方法是否已建立。
// 只在函式中呼叫其dispatch是ok的，因為dispatch方法和store物件一起建立，
// 即使dispatch方法會一直重建，因為是透過其父物件(store)關聯，
// 函式執行當下參照到的dispatch方法會是最新的。
import runtimeStore from '../index';

// 做一些共用處理
// apiUrl和option是fetch api原本的參數
export function fetchWrapper(apiUrl, option) {
   // 最後傳回的是一個promise物件，所以後續外部可以繼續接then
   return fetch(apiUrl, option)
      // 先抓錯誤
      // err是錯誤訊息物件，有message屬性描述錯誤訊息
      .catch(err => err)
      .then((res) => {
         // 有錯誤時會接收到catch回傳的err物件，不會有json方法
         if (res.json) {
            // 正常連線情況提取json文件
            switch (res.status) {
               case 200:
               default:
                  // res.json()是async方法，會傳回promise物件
                  // 其完成後傳回的value就是api傳回的json文件，會有result屬性
                  // 可以拿來和另一個情況的err物件做區別
                  return res.json();
            }
         } else {
            // 往下一個then傳遞err物件以統一處理錯誤訊息提示
            return res;
         }
      })
      // 這個then是為了能用到上一個then中的res.json()結果以對提示訊息統一做預處理
      .then((json) => {
         const result = json.result;
         let msg;
         if (!result) {
            // 印出err物件
            // err物件有message屬性，內容為錯誤描述字串
            msg = json.message;
         } else {
            // 處理異常訊息提示
            // dispatch異常訊息的函式是固定的，但每次dispatch都要傳，使用時用curry或bind做單1次處理
            // 已用參照runtimeStore的方式解決
            switch (result.status) {
               // 不顯示提示
               case '0':
               case '204':
                  break;
               // 顯示提示
               default:
                  msg = result.msg;
            }
         }
         // dispatch應該存在，不存在則console提示
         if (!runtimeStore.dispatch) console.error('Error: dispatch function is not existing.');
         else console.error(msg);

         // 將結果回傳到一般流程
         return json;
      });
};


// WEBPACK FOOTER //
// ./src/commonJS/fetchWrapper.js